import type { RecurrenceFrequency } from '../../../api/my-parking-spots';

const DAY_MS = 24 * 60 * 60 * 1000;
const WEEK_MS = 7 * DAY_MS;

export const WEEKLY_OCCURRENCE_OPTIONS = [4, 8, 12] as const;
export const DAILY_OCCURRENCE_OPTIONS = [7, 14, 30] as const;

export function recurrenceStepMs(frequency: RecurrenceFrequency): number {
  return frequency === 'DAILY' ? DAY_MS : WEEK_MS;
}

export function recurrenceOverlapsSelf(
  startAtIso: string,
  endAtIso: string,
  frequency: RecurrenceFrequency,
): boolean {
  return new Date(endAtIso).getTime() - new Date(startAtIso).getTime() >= recurrenceStepMs(frequency);
}

export function buildRecurrenceOccurrenceIsos(
  startAtIso: string,
  endAtIso: string,
  frequency: RecurrenceFrequency,
  occurrences: number,
): { startAt: string; endAt: string }[] {
  const startMs = new Date(startAtIso).getTime();
  const durationMs = new Date(endAtIso).getTime() - startMs;
  const step = recurrenceStepMs(frequency);
  return Array.from({ length: occurrences }, (_, index) => {
    const offset = index * step;
    return {
      startAt: new Date(startMs + offset).toISOString(),
      endAt: new Date(startMs + offset + durationMs).toISOString(),
    };
  });
}
